import { ordermanagerUrl, printingUrl } from "../resources";
import common from '../common/common.js';

async function updateOrderToReadyOrder(restaurant, payload) {
    let data = null;
    let command = {
        restaurantId : restaurant,
        orderId : payload.orderId,
        sendSMS : payload.sendSMS,
        sender : payload.sender,
        duration : payload.duration
    };
    let url = `${ordermanagerUrl}/UpdateOrderToReadyState`;
    await common.putData(url, command)
                .then(response => data = response.data);
    return data;
}


async function updateOrderPickupTime(restaurant, payload) {

    let data = null;
    let command = {
        restaurantId : restaurant,
        orderId : payload.orderId,
        newPickupTime : payload.newPickupTime
    };
    let url = `${ordermanagerUrl}/UpdateOrderPickupTime`;
    await common.putData(url, command)
                .then(response => data = response.data);
    return data;
}

async function updateOrderPickupDate(restaurant, payload) {

    let data = null;
    
    let url = `${ordermanagerUrl}/UpdateOrderPickupDate`;
    await common.putData(url, payload)
                .then(response => data = response.data);
    return data;
}

async function updateOrderPriorityOrAsap(restaurant, payload) {
    console.log('updateOrderPriorityOrAsap');
    let data = null;
    let command = {
        restaurantId : restaurant,
        orderId : payload.orderId,
        asap : payload.asap,
        priority : payload.priority
    };
    let url = `${ordermanagerUrl}/UpdateOrderPriorityOrAsap`;
    await common.putData(url, command)
                .then(response => data = response.data);
    console.log(data);
    return data;
}

async function updateCurrentWaitingTime(restaurant, payload) {
    let url = `${ordermanagerUrl}/UpdateCurrentWaitingTime`;
    let data = null;
    let command = {
        restaurantId : restaurant,
        waitingTime : payload
    };

    await common.putData(url, command)
                .then(response => data = response);

    return data;
}

async function updateCapacity(restaurant, payload) {
    let url = `${ordermanagerUrl}/updateCapacity`;
    let data = null;
    let command = {
        restaurantId : restaurant,
        capacity : payload
    };
    await common.putData(url, command)
                .then(response => data = response);
    return data;
}

async function printOrderFromClient(payload) {
    let url = `${printingUrl}/PrintOrderFromClient`;
    
    let data = null;

    await common.postData(url, payload)
                .then(response => data = response);
    return data;
}

async function cancelOrder(restaurant, payload) {
    let url = `${ordermanagerUrl}/cancelOrderById`;
    let data = null;
    let command = {
        restaurantId : restaurant,
        orderId : payload.orderId,
        reason : payload.reason
    }
    await common.putData(url, command)
                .then(res => data = res.data);
    return data;
}

export default {
    updateOrderToReadyOrder,
    updateOrderPickupTime,
    updateOrderPickupDate,
    updateOrderPriorityOrAsap,
    updateCurrentWaitingTime,
    updateCapacity,
    printOrderFromClient,
    cancelOrder
}